import { helpers } from '@vuelidate/validators'
import type { ValidatorFn } from '@vuelidate/core'

const username: ValidatorFn = (value): boolean => {
  return !helpers.req(value) ||
    (
      /^([a-z0-9_])+$/.test(value)
    )
}

export default username
